// Shared by Vue, the production server and the static HTML build.
const cards = require('./cards.json')

const SITE_URL = 'https://lithiumhome.ru'
const pages = Object.create(null)

function addPage (path, name, description, options = {}) {
  pages[path] = { path, name, title: name.includes('LITHIUM') ? name : `${name} | LITHIUM`, description, ...options }
}

function heading (prefix, name, suffix = '') {
  return { h1: prefix + name + suffix, heading: { prefix, name, suffix } }
}

function projectDetails (card) {
  const parts = card.caption.split('/').map(part => part.trim())
  const names = Object.values(cards).map(card => card.name)
  const models = parts[0].split('+').map(model => {
    const value = model.trim()
    return names.find(name => name.toUpperCase() === value.toUpperCase()) || value.charAt(0) + value.slice(1).toLowerCase()
  })
  const cities = { МОСКВА: 'Москва', КИРОВ: 'Киров', 'САНКТ-ПЕТЕРБУРГ': 'Санкт-Петербург' }
  const city = parts.map(part => cities[part.toUpperCase()]).find(Boolean)
  if (!city) throw new Error(`Missing project city: ${card.name}`)
  const kitchen = `${models.length > 1 ? 'кухни' : 'кухня'} ${models.join(' и ')}`
  return { kitchen, city }
}

addPage('/', 'Премиальные кухни, гардеробные и диваны на заказ', 'Кухни, гардеробные системы и диваны LITHIUM. Индивидуальные решения для вашего интерьера от производителя. Шоурумы в Москве и Кирове.')
addPage('/brand', 'О бренде LITHIUM', 'LITHIUM — российский производитель мебели. Узнайте о подходе бренда к дизайну, материалам, технологиям и индивидуальным интерьерным решениям.')
addPage('/service', 'Послепродажное обслуживание', 'Послепродажное обслуживание мебели LITHIUM. Отправьте обращение в сервисную службу, опишите вопрос и приложите фотографии.')
addPage('/friends', 'LITHIUM Friends', 'Программа LITHIUM Friends для дизайнеров и архитекторов. Узнайте об условиях сотрудничества, поддержке проектов и работе с продукцией LITHIUM.')
addPage('/catalog', 'Коллекция кухонь', 'Коллекция кухонь LITHIUM: дизайн-концепты, фотографии и возможности персонализации. Подберите решение для вашего интерьера.')
addPage('/products', 'Продукция LITHIUM', 'Продукция LITHIUM: кухни, гардеробные системы и диваны. Ознакомьтесь с коллекциями и выберите мебель для вашего интерьера.')
addPage('/products/kitchens', 'Премиальные кухни', 'Премиальные кухни LITHIUM по индивидуальному проекту. Коллекция дизайн-концептов, выбор материалов и персонализация для вашего пространства.')
addPage('/products/wardrobes', 'Гардеробные системы', 'Гардеробные системы LITHIUM: открытые композиции и индивидуальные решения для хранения. Ознакомьтесь с дизайном, материалами и возможностями исполнения.')
addPage('/products/sofas', 'Диваны LITHIUM', 'Коллекция диванов LITHIUM: Platform, Piano, Sierra, Wave, Dune, Haven, Monfort и Lowell. Выберите модель для вашего интерьера.')
addPage('/contacts', 'Контакты и шоурумы', 'Шоурумы LITHIUM в Москве и Кирове: адреса, телефоны и часы работы. Контакты производства и отделов компании.')
addPage('/design', 'Дизайн мебели', 'Дизайн мебели LITHIUM: материалы, внимание к деталям и продуманная функциональность. Узнайте о персонализации кухонь и интерьерных решений.')
addPage('/contract', 'LITHIUM Contract', 'LITHIUM Contract — мебельные решения для архитектурных проектов. Ознакомьтесь с подходом к сотрудничеству и реализованными объектами.')
addPage('/interior', 'Интерьерные решения', 'Интерьерные решения LITHIUM: гостиные, гардеробные, мебель для ванных комнат и стеновые панели. Мебель в едином стиле для вашего пространства.')
addPage('/projects', 'Реализованные проекты', 'Реализованные проекты LITHIUM: кухни, гардеробные и мебель в интерьерах. Фотографии, дизайн-концепты и примеры индивидуальных решений.')
addPage('/application', 'Обсудить проект мебели', 'Оставьте заявку на расчёт мебели LITHIUM. Расскажите о вашем проекте, чтобы обсудить кухню, гардеробную или другое интерьерное решение.')
addPage('/policy', 'Политика обработки персональных данных', 'Политика ООО «Литиум Техник» в отношении обработки персональных данных: цели обработки, права пользователей и сведения об операторе.')
addPage('/ceramics', 'Керамические поверхности Inalco', 'Керамические поверхности Inalco в коллекции LITHIUM. Ознакомьтесь с цветами, фактурами и примерами применения материала в интерьерах.')

const sectionHeadings = {
  '/brand': 'О фабрике LITHIUM: российский производитель премиальной мебели',
  '/friends': 'LITHIUM Friends: программа для дизайнеров и архитекторов',
  '/contract': 'LITHIUM Contract: мебель для коммерческих и жилых проектов',
  '/projects': 'Реализованные проекты LITHIUM: кухни и гардеробные в интерьерах',
  '/contacts': 'Шоурумы LITHIUM в Москве и Кирове',
  '/design': 'Дизайн и персонализация мебели LITHIUM',
  '/ceramics': 'Керамические поверхности Inalco для кухонь и интерьеров'
}
for (const [path, h1] of Object.entries(sectionHeadings)) pages[path].h1 = h1

addPage('/applicationaccepted', 'Ваша заявка принята', 'Заявка на расчёт мебели LITHIUM принята. Менеджер свяжется с вами для обсуждения проекта.', { noindex: true })
addPage('/cl-accepted', 'Ваша заявка принята', 'Заявка LITHIUM принята. Менеджер свяжется с вами для обсуждения деталей.', { noindex: true })
addPage('/personal', 'Согласие на обработку персональных данных', 'Согласие на обработку персональных данных при обращении в LITHIUM.', { noindex: true })
addPage('/capital-living', 'Capital Living', 'Capital Living — интерьерные решения LITHIUM. Информация о проекте и форма обращения.', { noindex: true })
addPage('/taplink', 'Связаться с LITHIUM', 'Свяжитесь с LITHIUM по телефону, электронной почте или в мессенджерах.', { noindex: true })

for (const [path, card] of Object.entries(cards)) {
  if (path.startsWith('/catalog/')) {
    addPage(path, `Кухня ${card.name}`, `Кухня ${card.name} из коллекции LITHIUM. Фотографии дизайн-концепта, материалы и возможности персонализации для вашего интерьера.`, {
      breadcrumbName: card.name,
      title: `Кухня ${card.name} на заказ в Москве: премиальная кухня от фабрики LITHIUM`,
      ...heading('Кухня ', card.name, ' на заказ'),
      imageAlt: `Кухня ${card.name}`
    })
  } else if (path.startsWith('/projects/')) {
    const { kitchen, city } = projectDetails(card)
    addPage(path, `Проект ${card.name}`, `Реализованный проект ${card.name}: ${card.caption}. Фотографии интерьера и мебели LITHIUM.`, {
      breadcrumbName: card.name,
      title: `Проект ${card.name}: ${kitchen} в интерьере, ${city} | LITHIUM`,
      ...heading('Проект ', card.name + ':', ` ${kitchen} в интерьере`),
      imageAlt: `Проект ${card.name}, ${kitchen}`
    })
  } else if (path.startsWith('/ceramics/')) {
    addPage(path, `Керамические поверхности ${card.name}`, `Керамические поверхности Inalco ${card.name} для интерьера. Фотографии коллекции, цвет и фактура в каталоге LITHIUM.`, {
      breadcrumbName: card.name,
      title: `Керамическая столешница Inalco ${card.name} для кухни | LITHIUM`,
      ...heading('Керамическая поверхность Inalco ', card.name),
      imageAlt: `Керамика Inalco ${card.name}`
    })
  } else if (path.startsWith('/products/sofas/')) {
    addPage(path, `Диван ${card.name}`, `Диван ${card.name} LITHIUM. Ознакомьтесь с дизайном модели и деталями исполнения для вашего интерьера.`, {
      breadcrumbName: card.name,
      title: `Модульный диван ${card.name} на заказ в Москве от LITHIUM`,
      ...heading('Модульный диван ', card.name),
      imageAlt: `Диван ${card.name}`
    })
  }
}

const aliases = {
  '/sofas': '/products/sofas',
  '/sofas/platform': '/products/sofas/platform'
}

const notFound = {
  title: 'Страница не найдена | LITHIUM',
  name: 'Страница не найдена',
  description: 'Запрашиваемая страница не найдена. Перейдите на главную страницу или ознакомьтесь с продукцией LITHIUM.',
  noindex: true
}

function resolvePath (requestPath) {
  let path
  try {
    path = decodeURIComponent(requestPath.split(/[?#]/)[0])
  } catch (error) {
    return null
  }
  path = path.replace(/\/+$/, '') || '/'
  path = path.replace(/\/index\.(html|php)$/i, '') || '/'
  path = path.toLowerCase()
  path = aliases[path] || path
  if (path.startsWith('/production/')) path = path.replace('/production/', '/products/')
  return pages[path] ? path : null
}

function getPage (requestPath) {
  const path = resolvePath(requestPath)
  return path ? pages[path] : notFound
}

function getBreadcrumbs (page) {
  if (!page.path || page.noindex || page.path === '/') return []
  const paths = ['/']
  const segments = page.path.slice(1).split('/')
  for (let index = 1; index <= segments.length; index++) {
    const path = `/${segments.slice(0, index).join('/')}`
    if (pages[path]) paths.push(path)
  }
  return paths.map(path => ({
    name: path === '/' ? 'Главная' : pages[path].breadcrumbName || pages[path].name,
    item: SITE_URL + path
  }))
}

module.exports = { SITE_URL, pages, aliases, notFound, resolvePath, getPage, getBreadcrumbs }
